/**
 * Part of rayband project.
 *
 * @copyright  Copyright (C) 2023 __ORGANIZATION__.
 * @license    __LICENSE__
 */
import TwCitySelector from '../../../../www/assets/vendor/tw-city-selector';

export function AppPlugin(app) {
  app.config.globalProperties.$lang = (id, ...args) => {
    return u.__(id, ...args);
  };

  app.config.globalProperties.$getDecimalPlace = (num) => {
    if (!!(num % 1)) {
      return 1;
    }

    return 0;
  }

  app.config.globalProperties.$formatPrice = (
    num,
    addCode = false,
    addSpace = false,
    decimalPlace = 2,
    floor = false,
    decimalPoint = '.',
    separator = ',',
  ) => {
    let negative = num < 0;
    num = Math.abs(num);

    if (floor) {
      num = Math.floor(num);
    }

    let formatted = u.numberFormat(num, decimalPlace, decimalPoint, separator);

    let space = addSpace ? ' ' : '';

    formatted = '$' + space + formatted;

    if (negative) {
      return '-' + formatted;
    }

    if (addCode) {
      formatted = 'NT' + formatted;
    }

    return formatted;
  };
}

AppPlugin.citySelector = {
  mounted(el, { value }) {
    value = value || {};

    el.id = el.id || u.uid('city-selector-');

    value.el = '#' + el.id;

    u.module(el, 'city.selector', (el) => new TwCitySelector(value));
  }
}

AppPlugin.Colorpicker = {
  async mounted(el, { value }) {
    await u.$ui.colorPicker();
    Spectrum.getInstance(el, Object.assign({}, value));
  },
  updated(el, { value }) {
    const sp = Spectrum.getInstance(el);

    if (JSON.stringify(value) !== JSON.stringify(sp.options)) {
      sp.rebuild(Object.assign({}, value));
    }
  },
  unmounted(el) {
    const sp = Spectrum.getInstance(el);
    sp.destroy();
  }
};
